export const SUPPORT_LINK = 'https://support.datacamp.com';
export default {
  SUPPORT_LINK
};